import { fetcher } from "helpers/fetcher";

import {
  TUpdateJobListingCertificationReq,
  TUpdateJobListingRequirementsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateJobListingCertification = async (
  payload: TUpdateJobListingCertificationReq
) => {
  return await fetcher<
    TUpdateJobListingRequirementsRes,
    TUpdateJobListingCertificationReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_CERTIFICATION, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_CERTIFICATION.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateJobListingCertification = async (
  payload: TUpdateJobListingCertificationReq
) => {
  return (await updateJobListingCertification(payload)).data;
};

mutationUpdateJobListingCertification._key = (
  payload: TUpdateJobListingCertificationReq
) => [ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_CERTIFICATION.url, payload];
